import { UPDATE_CART_LOGIN_TOKENS } from './cartLogin.action';
import { CartLoginToken } from '@whiz-cart/node-shared/models/account/cartLoginToken';

export default (
    state: {
        tokens: CartLoginToken[];
    } = { tokens: [] },
    {
        type,
        tokens,
    }: {
        type: string;
        tokens: CartLoginToken[];
    },
) => {
    switch (type) {
        case UPDATE_CART_LOGIN_TOKENS:
            return { ...state, tokens };
        default:
            return state;
    }
};
